import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import RegistrationForm from './RegistrationForm';
import ConfirmByPhoneForm from './ConfirmByPhoneForm';
import ConfirmByEmailPage from './ConfirmByEmailPage';
import AuthLayout from '../AuthLayout';

export default function () {
  return (
    <AuthLayout>
      <Routes>
        <Route path="/" element={<RegistrationForm confirmByPhoneUrl="./confirm-by-phone" />} />
        <Route path="/confirm-by-phone" element={<ConfirmByPhoneForm redirectUrl="/login" />} />
        <Route
          path="/confirm-by-email/:code"
          element={<ConfirmByEmailPage redirectUrl="/login" />}
        />
        <Route path="/*" element={<Navigate to="./" replace />} />
      </Routes>
    </AuthLayout>
  );
}
